// Decorative background video band: grayscale (B&W) video + brand-red overlay.
// - Poster image is always rendered (mobile + fallback while video loads).
// - Video only loads/plays on md+ screens for performance (preload="none").
// - `redOpacity` is 0-100 (matches the editor overlay opacity scale).
export const BgVideo = ({
  videoUrl,
  poster,
  redOpacity = 45,
  darken = 35,
  className = "",
  children,
  testid,
}) => {
  const redA = Math.max(0, Math.min(100, redOpacity)) / 100;
  const darkA = Math.max(0, Math.min(100, darken)) / 100;
  return (
    <div className={`relative isolate overflow-hidden bg-black ${className}`} data-testid={testid}>
      {poster && (
        <img
          src={poster}
          alt=""
          aria-hidden="true"
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover [filter:grayscale(1)_contrast(1.05)]"
        />
      )}
      {videoUrl && (
        <video
          className="absolute inset-0 hidden h-full w-full object-cover [filter:grayscale(1)_contrast(1.05)] md:block"
          autoPlay
          muted
          loop
          playsInline
          preload="none"
          poster={poster}
          aria-hidden="true"
          data-testid={testid ? `${testid}-video` : undefined}
        >
          <source src={videoUrl} type="video/webm" />
        </video>
      )}
      {/* contrast darken */}
      <div className="absolute inset-0" style={{ backgroundColor: `rgba(0,0,0,${darkA})` }} aria-hidden="true" />
      {/* brand-red overlay */}
      <div className="absolute inset-0" style={{ backgroundColor: `rgba(225,29,56,${redA})` }} aria-hidden="true" />
      <div className="relative z-[2]">{children}</div>
    </div>
  );
};
